'use strict';

var GridToolbarDirective = function GridToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: {
      'controls': '?rmGridRowSelectionButtons',
      'middle-controls': '?rmGridMiddleToolbar',
      'expandCollapse-controls': '?rmGridExpandButton'
    },
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar.html'),
    controller: 'GridToolbarController'
  };
};
GridToolbarDirective.$inject = [];
module.exports = GridToolbarDirective;